import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=ad16add8&scoped=true&"
import script from "./TaskOverview.vue?vue&type=script&lang=js&"
export * from "./TaskOverview.vue?vue&type=script&lang=js&"
import style0 from "./TaskOverview.vue?vue&type=style&index=0&id=ad16add8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad16add8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad16add8')) {
      api.createRecord('ad16add8', component.options)
    } else {
      api.reload('ad16add8', component.options)
    }
    module.hot.accept("./TaskOverview.vue?vue&type=template&id=ad16add8&scoped=true&", function () {
      api.rerender('ad16add8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Overview/TaskOverview.vue"
export default component.exports